import React from 'react';

// TODO: [添削] Storybook未実装
export const ImageThumbnail: React.FC<{ url: string }> = ({ url }) => (
  <a target="_blank" rel="noopener noreferrer" href={url}>
    <img src={url} width={100} height={100} alt="" title="クリックで画像を開きます" />
  </a>
);
